"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientResponseOption = exports.ResponseOptionClientMembership = exports.ResponseOption = exports.ResponseOptionTypeEnum = void 0;
var cerealParse_1 = require("../cerealParse");
var ResponseOptionTypeEnum;
(function (ResponseOptionTypeEnum) {
    ResponseOptionTypeEnum[ResponseOptionTypeEnum["positive"] = 0] = "positive";
    ResponseOptionTypeEnum[ResponseOptionTypeEnum["negative"] = 1] = "negative";
})(ResponseOptionTypeEnum = exports.ResponseOptionTypeEnum || (exports.ResponseOptionTypeEnum = {}));
/**
 * Class representing a response option and providing a static parse method.
 */
var ResponseOption = /** @class */ (function () {
    function ResponseOption(id, text, type, canDelete) {
        this.id = id;
        this.text = text;
        this.type = type;
        this.canDelete = canDelete;
    }
    /**
     * Parse object potentially representing a ResponseOption.
     * @param o
     * @return Parse result
     */
    ResponseOption.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ResponseOption(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'text'), cerealParse_1.ParseUtils.getEnum(o, 'type', ResponseOptionTypeEnum), cerealParse_1.ParseUtils.getBoolean(o, 'canDelete')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ResponseOption: " + e.message);
        }
    };
    /**
     * Compare two ResponseOption instances based on type and localCompare.
     * @param a
     * @param b
     * @return Number representing comparison.
     */
    ResponseOption.compare = function (a, b) {
        var aTypePoint = a.type == ResponseOptionTypeEnum.positive ? 0 : 1;
        var bTypePoint = b.type == ResponseOptionTypeEnum.positive ? 0 : 1;
        return aTypePoint - bTypePoint || a.text.localeCompare(b.text) || a.id.localeCompare(b.id);
    };
    return ResponseOption;
}());
exports.ResponseOption = ResponseOption;
/**
 * Class representing a response option client membership and providing a static parse method.
 */
var ResponseOptionClientMembership = /** @class */ (function () {
    function ResponseOptionClientMembership(id, clientId, clientName, groupId, groupName, groupColor, hasResponseOption, canRemove) {
        this.id = id;
        this.clientId = clientId;
        this.clientName = clientName;
        this.groupId = groupId;
        this.groupName = groupName;
        this.groupColor = groupColor;
        this.hasResponseOption = hasResponseOption;
        this.canRemove = canRemove;
    }
    /**
     * Parse object potentially representing a ResponseOptionClientMembership.
     * @param o
     * @return Parse result
     */
    ResponseOptionClientMembership.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ResponseOptionClientMembership(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'clientId'), cerealParse_1.ParseUtils.getString(o, 'clientName'), cerealParse_1.ParseUtils.getString(o, 'groupId'), cerealParse_1.ParseUtils.getString(o, 'groupName'), cerealParse_1.ParseUtils.getString(o, 'groupColor'), cerealParse_1.ParseUtils.getBoolean(o, 'hasResponseOption'), cerealParse_1.ParseUtils.getBooleanOrNull(o, 'canRemove')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ResponseOptionClientMembership: " + e.message);
        }
    };
    return ResponseOptionClientMembership;
}());
exports.ResponseOptionClientMembership = ResponseOptionClientMembership;
/**
 * Class representing a client response option and providing a static parse method.
 */
var ClientResponseOption = /** @class */ (function () {
    function ClientResponseOption(id, text, type, hasResponseOption) {
        this.id = id;
        this.text = text;
        this.type = type;
        this.hasResponseOption = hasResponseOption;
    }
    /**
     * Parse object potentially representing a ClientResponseOption.
     * @param o
     * @return Parse result
     */
    ClientResponseOption.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientResponseOption(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'text'), cerealParse_1.ParseUtils.getEnum(o, 'type', ResponseOptionTypeEnum), cerealParse_1.ParseUtils.getBoolean(o, 'hasResponseOption')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientResponseOption: " + e.message);
        }
    };
    /**
     * Create new ResponseOption instance based on ClientResponseOption.
     * @return New ResponseOption instance.
     */
    ClientResponseOption.prototype.toResponseOption = function () {
        return new ResponseOption(this.id, this.text, this.type, false);
    };
    return ClientResponseOption;
}());
exports.ClientResponseOption = ClientResponseOption;
//# sourceMappingURL=responseOption.js.map